module.exports = __webpack_public_path__ + "img/silver-vip.12ec899c.svg";